"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const context_1 = require("./context");
const computeShader_1 = require("./computeShader");
const renderTarget_1 = require("./renderTarget");
const vectorBoolArray_1 = require("./vectorBoolArray");
const vectorInt16_1 = require("./vectorInt16");
const vectorUint16_1 = require("./vectorUint16");
const functionStrings_1 = require("./functionStrings");
module.exports = {
    setWebGLContext: context_1.setWebGLContext,
    getWebGLContext: context_1.getWebGLContext,
    isWebGL2: context_1.isWebGL2,
    ComputeShader: computeShader_1.ComputeShader,
    passThruFrag: computeShader_1.passThruFrag,
    passThruVert: computeShader_1.passThruVert,
    RenderTarget: renderTarget_1.RenderTarget,
    packBooleans: vectorBoolArray_1.packBooleans,
    unpackBooleans: vectorBoolArray_1.unpackBooleans,
    packInt16: vectorInt16_1.packInt16,
    unpackInt16: vectorInt16_1.unpackInt16,
    MIN_INT16: vectorInt16_1.MIN_INT16,
    MAX_INT16: vectorInt16_1.MAX_INT16,
    packUint16: vectorUint16_1.packUint16,
    unpackUint16: vectorUint16_1.unpackUint16,
    MIN_UINT16: vectorUint16_1.MIN_UINT16,
    MAX_UINT16: vectorUint16_1.MAX_UINT16,
    functionStrings: functionStrings_1.functionStrings
};
var context_2 = require("./context");
exports.setWebGLContext = context_2.setWebGLContext;
exports.getWebGLContext = context_2.getWebGLContext;
exports.isWebGL2 = context_2.isWebGL2;
var computeShader_2 = require("./computeShader");
exports.ComputeShader = computeShader_2.ComputeShader;
exports.passThruFrag = computeShader_2.passThruFrag;
exports.passThruVert = computeShader_2.passThruVert;
var renderTarget_2 = require("./renderTarget");
exports.RenderTarget = renderTarget_2.RenderTarget;
var vectorBoolArray_2 = require("./vectorBoolArray");
exports.packBooleans = vectorBoolArray_2.packBooleans;
exports.unpackBooleans = vectorBoolArray_2.unpackBooleans;
var vectorInt16_2 = require("./vectorInt16");
exports.packInt16 = vectorInt16_2.packInt16;
exports.unpackInt16 = vectorInt16_2.unpackInt16;
exports.MIN_INT16 = vectorInt16_2.MIN_INT16;
exports.MAX_INT16 = vectorInt16_2.MAX_INT16;
var vectorUint16_2 = require("./vectorUint16");
exports.packUint16 = vectorUint16_2.packUint16;
exports.unpackUint16 = vectorUint16_2.unpackUint16;
exports.MIN_UINT16 = vectorUint16_2.MIN_UINT16;
exports.MAX_UINT16 = vectorUint16_2.MAX_UINT16;
var functionStrings_2 = require("./functionStrings");
exports.functionStrings = functionStrings_2.functionStrings;
//# sourceMappingURL=index.js.map